<template lang="pug">
.reminderItem
  v-row.align-center.ma-0.px-4.py-1(
      style="background-color: var(--v-basic600T08); margin:0 -24px 16px !important;",
      v-if="isFirstDate"
    )
      v-col.ma-0.pa-0.px-2
        .s2.primary400--text {{ getMonth(reminder.date) }}
  v-row()
    v-col.text-center.py-0(style="max-width: 55px")
      .button-AA-small.primary400--text.text-uppercase(
        :class="{ todayDay: isToday(reminder.date) }"
      ) {{ getDayStr(reminder.date) }}
      .s1.primary--text.text-center(
        :class="{ todayDate: isToday(reminder.date) }"
      ) {{ reminder.date.split('-')[2] }}
    v-col.py-0.mr-4()
      div(
        v-for="item in reminder.reminders",
        :key="item.id"
      )
        reminder-item-list(:item="item" @stopped="$emit('stopped')")
</template>
<script>
import ReminderItemList from '@/components/yezzabook/dialogs/ReminderItemList.vue'

export default {
  name: "ReminderItem",
  components: {ReminderItemList},
  props: ["reminder","isFirstDate"],
  data() {
    return {
      dayList: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
    };
  },
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  methods: {
    isToday(date) {
      var currentDate = new Date();
      var day = ("0"+currentDate.getDate()).slice(-2);
      var month = ("0"+(currentDate.getMonth() + 1)).slice(-2);
      var year = currentDate.getFullYear();
      var today = year + "-" + month + "-" + day;
      if (today == date) {
        return true;
      } else {
        return false;
      }
    },
    getDayStr(date) {
      var data = date.split("-");
      var newDate = data[1] + "/" + data[2] + "/" + data[0];
      newDate = new Date(newDate);
      var dayIndex = newDate.getDay();
      var day = this.dayList[dayIndex];
      return day;
    },
    getMonth(val) {
      var dateArray = val.split("-");
      var month = this.months[dateArray[1] - 1];
      var year = dateArray[0];
      return month + " " + year;
    },
  },
  mounted() {},
};
</script>
<style scoped>
.todayDate {
  background-color: var(--v-info500);
  border-radius: 50%;
  color: white !important;
  width: 25px;
  margin: auto;
}
.todayDay {
  color: var(--v-info500) !important;
}
.sendFailed {
  background-color: var(--v-dangerT08) !important;
}
.listItem {
  background-color: var(--v-basic600T08);
  border-radius: 4px;
}
</style>